import { render, staticRenderFns } from "./PageUserOrders.vue?vue&type=template&id=b1d6832e&scoped=true&"
import script from "./PageUserOrders.vue?vue&type=script&lang=ts&"
export * from "./PageUserOrders.vue?vue&type=script&lang=ts&"
import style0 from "./PageUserOrders.vue?vue&type=style&index=0&id=b1d6832e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d6832e",
  null
  
)

export default component.exports